import Actions from "../actions";
import { produce } from "immer";

const initialState = {
    selectedUserChatId:'',
    selectedServiceProviderChatId:''
};


const serviceProviderChat = produce((draft = initialState, action) => {
  const { payload } = action;
  switch (action.type) {

    case Actions.SELECTED_USER_CHAT_ID: {
      draft.selectedUserChatId = payload?.selectedUserChatId;
      break;
    }

    case Actions.SELECTED_SERVICE_PROVIDER_CHAT_ID: {
      draft.selectedServiceProviderChatId = payload?.selectedServiceProviderChatId;
      break;
    }

    default: {
      break;
    }
  }
}, initialState);

export default serviceProviderChat;
